import { Navigate } from "react-router-dom";
import { useStaffAuth } from "../context/StaffAuthContext";

const PermissionGuard = ({ permissionKey, children }) => {
  const { loading, staff, hasPermission } = useStaffAuth();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-neutral-50 dark:bg-neutral-950 text-neutral-500 dark:text-neutral-400">
        Loading...
      </div>
    );
  }

  if (!staff) {
    return <Navigate to="/employee-login" replace />;
  }

  if (!hasPermission(permissionKey)) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-neutral-50 dark:bg-neutral-950">
        <div className="bg-white dark:bg-neutral-900 border border-neutral-200 dark:border-neutral-800 shadow-card dark:shadow-card-dark rounded-card p-8 max-w-md w-full mx-4">
          <h2 className="text-xl font-bold text-danger-500 dark:text-danger-500">
            Permission Denied
          </h2>
          <p className="mt-2 text-neutral-600 dark:text-neutral-300 text-sm">
            You do not have permission to perform this action.
          </p>
        </div>
      </div>
    );
  }

  return children;
};

export default PermissionGuard;
